// components/TravelPopup.jsx
import React from "react";
import { Dialog, Box, Typography, Avatar, Button, Stack } from "@mui/material";
import { WhatsApp, Phone, Close } from "@mui/icons-material";
import { useState } from "react";

const TravelPopup = ({ open, onClose , phone = "916230206562",
  defaultMessage = "Hi, I am interested in Himachal / Ladakh / Uttarakhand tour."}) => {
  const [message, setMessage] = useState(defaultMessage);

  const handleSend = () => {
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");

  };
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          p: 0,
          overflow: 'hidden',
          boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
          border: "1px solid #eee",
          animation: "fadeIn 0.5s ease-out"
        }
      }}
      // Add simple keyframe animation via inline style or global css
      sx={{
        "@keyframes fadeIn": {
          "0%": { opacity: 0, transform: "translateY(20px)" },
          "100%": { opacity: 1, transform: "translateY(0)" }
        }
      }}
    >
      <Box sx={{ p: 4, textAlign: 'center', position: 'relative', bgcolor: "#fff" }}>
        
        {/* Close Button */}
        <Box 
          sx={{ 
            position: 'absolute', 
            top: 15, 
            right: 15,
            cursor: 'pointer',
            bgcolor: "#f5f5f5",
            borderRadius: "50%",
            width: 30, height: 30,
            display: "flex", alignItems: "center", justifyContent: "center",
            color: '#666'
          }}
          onClick={onClose}
        >
          <Close sx={{ fontSize: 18 }} />
        </Box>
        
        {/* Icon */}
        <Avatar sx={{ 
          bgcolor: '#e8f5e9', 
          width: 70, 
          height: 70, 
          mx: 'auto', 
          mb: 3,
          color: "#25D366"
        }}>
          <WhatsApp sx={{ fontSize: 40 }} />
        </Avatar>
        
        {/* Dark Text Content */}
        <Typography variant="h5" fontWeight={800} gutterBottom sx={{ color: '#1b5e20', mb: 0.5 }}>
          Start Your Journey
        </Typography>
        <Typography variant="body2" sx={{ color: '#555', mb: 4, lineHeight: 1.6 }}>
          Confused about where to go? Chat with our travel experts instantly.
        </Typography>

        <Stack direction="column" spacing={2}>
          <Button 
            variant="contained" 
            startIcon={<WhatsApp />}
           onClick={handleSend}
        
            sx={{ 
              bgcolor: "#25D366", 
              color: "#fff", 
              py: 1.5, 
              borderRadius: "12px", 
              boxShadow: "0 4px 12px rgba(37, 211, 102, 0.3)",
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 700,
              "&:hover": { bgcolor: "#128C7E" }
            }}
          >
            Chat on WhatsApp
          </Button>

          <Button 
            variant="outlined" 
            startIcon={<Phone />}
            onClick={onClose}
            sx={{ 
              borderColor: "#1b5e20", 
              color: "#1b5e20", 
              py: 1.5, 
              borderRadius: "12px",
              textTransform: 'none',
              fontWeight: 600,
              "&:hover": { bgcolor: '#f1f8e9', borderColor: "#1b5e20" }
            }}
          >
            Call Us
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default TravelPopup;